import N from "react";
import _ from "../../../../_virtual/upperFirst.js";
import E from "../../../../_virtual/isFunction.js";
import { clsx as F } from "../../../clsx/dist/clsx.js";
import { adaptEventHandlers as L } from "../util/types.js";
import { filterProps as X } from "../util/ReactUtils.js";
import { isNumber as h } from "../util/DataUtils.js";
import p from "../../../d3-shape/src/area.js";
import Y from "../../../d3-shape/src/line.js";
import A, { stepBefore as R, stepAfter as D } from "../../../d3-shape/src/curve/step.js";
import M from "../../../d3-shape/src/curve/natural.js";
import { monotoneY as $, monotoneX as K } from "../../../d3-shape/src/curve/monotone.js";
import x from "../../../d3-shape/src/curve/linear.js";
import T from "../../../d3-shape/src/curve/linearClosed.js";
import { bumpY as H, bumpX as I } from "../../../d3-shape/src/curve/bump.js";
import U from "../../../d3-shape/src/curve/basis.js";
import V from "../../../d3-shape/src/curve/basisOpen.js";
import q from "../../../d3-shape/src/curve/basisClosed.js";
function s(e) {
  "@babel/helpers - typeof";
  return s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, s(e);
}
function y() {
  return y = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var t in n)
        Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
    }
    return e;
  }, y.apply(this, arguments);
}
function P(e, r) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    r && (t = t.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, t);
  }
  return n;
}
function j(e) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? P(Object(n), !0).forEach(function(t) {
      z(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : P(Object(n)).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function z(e, r, n) {
  return r = G(r), r in e ? Object.defineProperty(e, r, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = n, e;
}
function G(e) {
  var r = J(e, "string");
  return s(r) == "symbol" ? r : r + "";
}
function J(e, r) {
  if (s(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var t = n.call(e, r);
    if (s(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
var S = {
  curveBasisClosed: q,
  curveBasisOpen: V,
  curveBasis: U,
  curveBumpX: I,
  curveBumpY: H,
  curveLinearClosed: T,
  curveLinear: x,
  curveMonotoneX: K,
  curveMonotoneY: $,
  curveNatural: M,
  curveStep: A,
  curveStepAfter: D,
  curveStepBefore: R
}, v = function(r) {
  return r.x === +r.x && r.y === +r.y;
}, c = function(r) {
  return r.x;
}, f = function(r) {
  return r.y;
}, Q = function(r, n) {
  if (E(r))
    return r;
  var t = "curve".concat(_(r));
  return (t === "curveMonotone" || t === "curveBump") && n ? S["".concat(t).concat(n === "vertical" ? "Y" : "X")] : S[t] || x;
}, W = function(r) {
  var n = r.type, t = n === void 0 ? "linear" : n, a = r.points, m = a === void 0 ? [] : a, o = r.baseLine, l = r.layout, b = r.connectNulls, g = b === void 0 ? !1 : b, d = Q(t, l), O = g ? m.filter(function(u) {
    return v(u);
  }) : m, i;
  if (Array.isArray(o)) {
    var w = g ? o.filter(function(u) {
      return v(u);
    }) : o, B = O.map(function(u, C) {
      return j(j({}, u), {}, {
        base: w[C]
      });
    });
    return l === "vertical" ? i = p().y(f).x1(c).x0(function(u) {
      return u.base.x;
    }) : i = p().x(c).y1(f).y0(function(u) {
      return u.base.y;
    }), i.defined(v).curve(d), i(B);
  }
  return l === "vertical" && h(o) ? i = p().y(f).x1(c).x0(o) : h(o) ? i = p().x(c).y1(f).y0(o) : i = Y().x(c).y(f), i.defined(v).curve(d), i(O);
}, br = function(r) {
  var n = r.className, t = r.points, a = r.path, m = r.pathRef;
  if ((!t || !t.length) && !a)
    return null;
  var o = t && t.length ? W(r) : a;
  return /* @__PURE__ */ N.createElement("path", y({}, X(r, !1), L(r), {
    className: F("recharts-curve", n),
    d: o,
    ref: m
  }));
};
export {
  br as Curve,
  W as getPath
};
